// extracted by mini-css-extract-plugin
export default {"modal":"viK8bQPKZOXVSE0baInl"};